
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { useToast } from "@/hooks/use-toast";

export const useRefundBooking = () => {
  const queryClient = useQueryClient();
  const { toast } = useToast();

  return useMutation({
    mutationFn: async (bookingId: string) => {
      console.log('Initiating refund for booking:', bookingId);
      
      const { data, error } = await supabase.functions.invoke('process-refund', {
        body: { bookingId }
      });

      if (error) {
        console.error('Refund function error:', error);
        throw error;
      }

      if (!data.success) {
        throw new Error(data.error || 'Refund failed');
      }

      console.log('Refund processed successfully:', data);
      return data;
    },
    onSuccess: (data) => {
      toast({
        title: "Refund Processed",
        description: `Refund of ${(data.amount / 100).toFixed(2)} has been initiated and will be processed within 5-10 business days. The booking status remains unchanged.`,
      });
      
      // Invalidate booking queries to refresh the data
      queryClient.invalidateQueries({ queryKey: ["provider-booking-detail"] });
      queryClient.invalidateQueries({ queryKey: ["provider-bookings"] });
    },
    onError: (error) => {
      console.error('Refund error:', error);
      toast({
        title: "Refund Failed",
        description: error?.message || "Failed to process refund. Please try again or contact support.",
        variant: "destructive",
      });
    },
  });
};
